import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";

function DoctorCard(props) {
  return (
    <div className="dt-card">
      <div className="dt-card-avatar">
        <img src={props.img} alt={props.name} />
      </div>

      <div className="dt-card-body">
        <h4 className="dt-card-name">{props.name}</h4>
        <p className="dt-card-role">{props.title}</p>
        {props.bio && <p className="dt-card-bio">{props.bio}</p>}

        <div className="dt-card-meta">
          <div className="dt-card-rating">
            <FontAwesomeIcon
              icon={faStar}
              style={{ color: "#F7BB50", marginRight: "8px" }}
            />
            <strong>{props.stars}</strong>
            <span className="dt-card-reviews"> ({props.reviews}+)</span>
          </div>

                  </div>
      </div>
    </div>
  );
}

export default DoctorCard;
